// Shared "Cerca cavallo" matcher: names use partial/case-insensitive/normalized match;
// identifiers (microchip, UELN/passaporto) use progressive prefix/substring match.
const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

export function matchHorse(item, query) {
  const q = norm(query);
  if (!q) return true;
  const names = [item.horse_name, item.horse_official_name];
  if (names.some((n) => norm(n).includes(q))) return true;
  const ids = [item.horse_microchip, item.horse_ueln];
  const qd = q.replace(/\s/g, "");
  return ids.some((id) => norm(id).replace(/\s/g, "").includes(qd));
}

// Adaptive Scadenzario filter: matches on horse name/official name/identifiers AND
// category/performance. Case + accent insensitive, partial, multi-token (each token
// must match somewhere in the combined haystack). e.g. "calvin aie" -> Calvin Klein's AIE.
export function matchDeadline(item, query) {
  const q = norm(query);
  if (!q) return true;
  const hay = norm([item.horse_name, item.horse_official_name, item.category, item.description,
    item.horse_microchip, item.horse_ueln].filter(Boolean).join(" "));
  return q.split(/\s+/).filter(Boolean).every((t) => hay.includes(t));
}
